import styled from '@emotion/styled';
import { RecoilRoot } from 'recoil';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import Cookie from 'js-cookie';
import TagManager from 'react-gtm-module';
import { client } from 'connectors/apollo';
import { initializeState } from 'state/initializeState';
import {
  BrowserFeaturesCheck,
  ErrorBoundary,
  Footer,
  AuthOverlay,
  LoaderOverlay,
  Breadcrumb,
  InfoModal,
  Header,
  Notification,
} from 'components';
import { Flex } from '@Calix-Commerce/design-system';

import { PageRoutes } from './Routes';
import { GlobalStyles, ThemeProvider } from '@Calix-Commerce/design-system/globals';

const AppStyled = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const MainContent = styled.div`
  flex-grow: 1;
`;

TagManager.initialize({ gtmId: import.meta.env.VITE_GTM_ID });

// Default the cookie domain
Cookie.withAttributes({ domain: import.meta.env.VITE_DEFAULT_COOKIE_DOMAIN });

const MaintenancePage = () => {
  return (
    <Flex alignment="baseline" spacing="space-around">
      <div>
        <h1>Maintenance</h1>
        <p>The My Calix Store is currently undergoing maintenance and will be back up shortly.</p>
      </div>
    </Flex>
  );
};

const App = () => {
  const inMaintenanceMode = import.meta.env.VITE_MAINTENANCE_MODE === 'true';

  return (
    <RecoilRoot initializeState={initializeState}>
      <GlobalStyles />
      {inMaintenanceMode ? (
        <MaintenancePage />
      ) : (
        <ErrorBoundary>
          <ThemeProvider>
            <BrowserFeaturesCheck>
              <ApolloProvider client={client}>
                <LoaderOverlay />
                <Notification />
                <AppStyled>
                  <InfoModal />
                  {/* {loadGA ? <GoogleAnalytics /> : null} */}
                  <BrowserRouter>
                    <AuthOverlay>
                      <Header />
                      <Breadcrumb />
                      <MainContent>
                        <PageRoutes />
                      </MainContent>
                      <Footer />
                    </AuthOverlay>
                  </BrowserRouter>
                </AppStyled>
              </ApolloProvider>
            </BrowserFeaturesCheck>
          </ThemeProvider>
        </ErrorBoundary>
      )}
    </RecoilRoot>
  );
};

export default App;
